import { initUI } from './ui.js';
import Lenis from '@studio-freight/lenis'

async function main() {
    // Initialize UI interactions
    initUI();

    // Control Menu
    const btnNav = document.querySelector('.btn-nav');
    const overlay = document.getElementById('mobile-menu-overlay');
    const navContent = document.querySelector('.nav-content');
    let menuOpen = false;

    function closeMenu() {
        if (typeof gsap !== 'undefined' && navContent) {
            const menuItems = navContent.querySelectorAll('li');
            if (menuItems.length > 0) {
                gsap.to(menuItems, {
                    duration: 0.3,
                    opacity: 0,
                    y: 20,
                    rotation: -4,
                    ease: "power2.in"
                });
            }
            gsap.to(navContent, { duration: 0.6, left: "-100%", ease: "power3.in" });
        }
        if (overlay && typeof gsap !== 'undefined') {
            overlay.style.pointerEvents = 'none';
            gsap.to(overlay, { duration: 0.6, opacity: 0, ease: "power3.in" });
        }
        if (btnNav) {
            btnNav.classList.remove('open', 'animated');
        }
        menuOpen = false;
    }

    if (btnNav) {
        btnNav.addEventListener('click', function () {
            if (!menuOpen) {
                if (typeof gsap !== 'undefined' && navContent) {
                    gsap.to(navContent, { duration: 0.6, left: "0%", ease: "power3.out" });
                }
                if (overlay && typeof gsap !== 'undefined') {
                    overlay.style.pointerEvents = 'auto';
                    gsap.to(overlay, { duration: 0.6, opacity: 1, ease: "power3.out" });
                }

                // Animate menu items from bottom to top with a slight clockwise rotation
                if (typeof gsap !== 'undefined' && navContent) {
                    const menuItems = Array.from(navContent.querySelectorAll('li')).reverse();
                    if (menuItems.length > 0) {
                        gsap.fromTo(menuItems, {
                            opacity: 0,
                            y: 30,
                            rotation: -4,
                            transformOrigin: "left center"
                        }, {
                            duration: 0.5,
                            opacity: 1,
                            y: 0,
                            rotation: 0,
                            stagger: 0.08,
                            ease: "power2.out",
                            delay: 0.15
                        });
                    }
                }

                btnNav.classList.add('animated', 'open');
                menuOpen = true;
            } else {
                closeMenu();
            }
        });
    }

    // Close menu when a link is clicked
    if (navContent) {
        const mobileLinks = navContent.querySelectorAll('a');
        mobileLinks.forEach(link => {
            link.addEventListener('click', closeMenu);
        });
    }

    if (overlay) {
        overlay.addEventListener('click', closeMenu);
    }

    // Listen for custom close events from other components
    window.addEventListener('context-close-menu', closeMenu);

    // Get a reference to the container element
    const container = document.querySelector('#scene-container');

    const isAboutPage = window.location.pathname.includes('about-us') || window.location.pathname.includes('join-the-team');

    if (container) {
        // Dynamically import World to prevent bundling Three.js on pages where it is not used
        const { World } = await import('./World/World.js');

        // create a new world
        const world = new World(container, { isAboutPage });

        // Add a safety timeout to ensure the loader is hidden even if something goes wrong
        const safetyTimeout = setTimeout(() => {
            console.warn('Loading safety timeout reached. Forcing loader to hide.');
            window.dispatchEvent(new CustomEvent('model-load-progress', { detail: 100 }));
        }, 15000);

        // complete async tasks
        try {
            await world.init();
            clearTimeout(safetyTimeout);
        } catch (error) {
            console.error('Error during world initialization:', error);
            // Even if it fails, we want to allow the user to see the site
            window.dispatchEvent(new CustomEvent('model-load-progress', { detail: 100 }));
        }

        // start the animation loop
        world.start();

        // Pause 3D rendering loop when the tab is in the background to eliminate CPU/GPU load
        document.addEventListener('visibilitychange', () => {
            if (document.hidden) {
                world.stop();
            } else {
                world.start();
            }
        });
    }

    // start Lenis smooth scroll
    const lenis = new Lenis({
        duration: 1.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        orientation: 'vertical',
        gestureOrientation: 'vertical',
        smoothWheel: true,
        wheelMultiplier: 1,
        smoothTouch: false,
        touchMultiplier: 2,
        infinite: false,
    });

    // Synchronize Lenis with ScrollTrigger
    lenis.on('scroll', () => {
        if (typeof ScrollTrigger !== 'undefined') {
            ScrollTrigger.update();
        }
    });

    // Use GSAP ticker to drive Lenis RAF
    gsap.ticker.add((time) => {
        lenis.raf(time * 1000);
    });

    // Disable lag smoothing to prevent desync during heavy loads
    gsap.ticker.lagSmoothing(0);

    // Make scroll indicator clickable
    const indicator = document.getElementById('scroll-indicator');
    if (indicator) {
        indicator.addEventListener('click', () => {
            lenis.scrollTo('#trigger-two');
        });
    }

    // Stop scrolling initially only if front-page intro is present and user is at the top of the page
    const hasIntro = document.getElementById('intro-text') !== null;
    const isAtTop = window.scrollY < 10;
    if (hasIntro && isAtTop) {
        lenis.stop();
    } else {
        document.documentElement.classList.remove('no-scroll');
    }


    if (hasIntro && isAtTop) {
        window.addEventListener('intro-finished', () => {
            document.documentElement.classList.remove('no-scroll');
            lenis.start();

            const indicator = document.getElementById('scroll-indicator');
            if (indicator) {
                indicator.classList.remove('opacity-0');

                // Use fromTo to ensure starting opacity of 1 is captured correctly by GSAP
                gsap.fromTo(indicator,
                    { opacity: 1 },
                    {
                        opacity: 0,
                        scrollTrigger: {
                            trigger: "#intro-text",
                            start: "top top",
                            end: "20% top",
                            scrub: true
                        }
                    }
                );
            }
        });
    }

    if (!isAboutPage && document.getElementById('bg-pattern')) {
        const introText = document.getElementById('intro-text');
        const endSection = document.getElementById('end');
        const footerEl = document.querySelector('footer');

        // Fade pattern out as user scrolls past hero
        gsap.fromTo("#bg-pattern",
            { opacity: 1 },
            {
                opacity: 0.2, // Your requested 0.2 fade down
                scrollTrigger: {
                    trigger: introText ? "#intro-text" : "body",
                    start: "top top",
                    end: introText ? "bottom top" : "400px top",
                    scrub: true
                }
            }
        );

        // Fade pattern back up a bit for the footer
        const footerTrigger = endSection ? "#end" : (footerEl ? "footer" : null);
        if (footerTrigger) {
            gsap.fromTo("#bg-pattern",
                { opacity: 0.2 }, // Start exactly where the previous trigger left off
                {
                    opacity: 0.6, // Your requested 0.6 footer fade up
                    immediateRender: false, // Prevents GSAP from forcing opacity to 0.2 on load!
                    scrollTrigger: {
                        trigger: footerTrigger,
                        start: "top bottom",
                        end: "bottom bottom",
                        scrub: true
                    }
                }
            );
        }
    }


    // Heading text reveal animation
    const headings = document.querySelectorAll('h1, h2, h3, h4, h5, dt');

    headings.forEach(heading => {
        if (heading.closest('#intro-text') || heading.closest('#tab-panes-track') || heading.closest('#context-invaders-modal')) return;

        const textNodes = [];
        const walk = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT, null, false);
        let n;
        while (n = walk.nextNode()) textNodes.push(n);

        textNodes.forEach(node => {
            const fragment = document.createDocumentFragment();
            const text = node.textContent;
            for (let char of text) {
                if (char.trim() === '' && char !== ' ') {
                    fragment.appendChild(document.createTextNode(char));
                } else {
                    const span = document.createElement('span');
                    span.textContent = char;
                    span.style.opacity = '0';
                    span.classList.add('char-reveal');
                    fragment.appendChild(span);
                }
            }
            node.parentNode.replaceChild(fragment, node);
        });

        gsap.to(heading.querySelectorAll('.char-reveal'), {
            scrollTrigger: {
                trigger: heading,
                start: "top 85%",
                toggleActions: "play none none reverse"
            },
            opacity: 1,
            duration: 0.3,
            stagger: 0.02,
            ease: "power2.out"
        });
    });

    // Footer logo animation
    gsap.fromTo("#footer-bg-logo",
        { scale: 0.95 },
        {
            scale: 1.05,
            ease: "none",
            scrollTrigger: {
                trigger: "#footer-bg-logo",
                start: "top bottom",
                end: "bottom top",
                scrub: true
            }
        }
    );

    // Footer logo spotlight effect
    const footerLogo = document.getElementById('footer-bg-logo');
    if (footerLogo) {
        let mouseX = -9999;
        let mouseY = -9999;
        let scheduled = false;

        const updateSpotlight = () => {
            const rect = footerLogo.getBoundingClientRect();
            const x = mouseX - rect.left;
            const y = mouseY - rect.top;
            footerLogo.style.setProperty('--mouse-x', `${x}px`);
            footerLogo.style.setProperty('--mouse-y', `${y}px`);
            scheduled = false;
        };

        window.addEventListener('mousemove', (e) => {
            mouseX = e.clientX;
            mouseY = e.clientY;
            if (!scheduled) {
                requestAnimationFrame(updateSpotlight);
                scheduled = true;
            }
        });

        window.addEventListener('scroll', () => {
            if (!scheduled && mouseX !== -9999) {
                requestAnimationFrame(updateSpotlight);
                scheduled = true;
            }
        });
    }


    // Animate Job Cards and Pager
    const jobCards = document.querySelectorAll('.job-card');
    const pager = document.querySelector('.opportunities-pager');

    if (jobCards.length > 0) {
        gsap.fromTo(jobCards,
            { opacity: 0, y: 30 },
            {
                opacity: 1,
                y: 0,
                duration: 0.6,
                stagger: 0.08,
                ease: "power2.out"
            }
        );
    }

    if (pager) {
        gsap.fromTo(pager,
            { opacity: 0, y: 20 },
            {
                opacity: 1,
                y: 0,
                duration: 0.8,
                delay: Math.min(jobCards.length * 0.08, 0.6) + 0.1,
                ease: "power2.out"
            }
        );
    }

}

main().catch((err) => {
    console.error(err);
});
